// extracted by mini-css-extract-plugin
export default {"input":"Number_input__rBetN"};